import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { PageHero, SectionTitle, Card } from '../components/PageUI';

const PlanosPage = () => {
  const plans = [
    { title: 'Básico', desc: 'Para operações compactas.', items: ['ERP essencial', 'Suporte online', 'Treinamento inicial'] },
    { title: 'Profissional', desc: 'Para crescer com escala.', items: ['ERP + PDV', 'App vendas e entregas', 'BI integrado'], featured: true },
    { title: 'Enterprise', desc: 'Operações complexas.', items: ['Fluxos avançados', 'SLA dedicado', 'Integrações'] }
  ];

  return (
    <div>
      <PageHero
        eyebrow="Planos e preços"
        title="Solução personalizada para o seu negócio."
        subtitle="Definimos o investimento ideal a partir do seu volume, módulos e integrações."
        primaryCta={{ label: 'Solicitar orçamento', href: '/especialista' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Planos"
            title="Escolha o pacote ideal"
            description="Todos os planos incluem suporte, atualizações e onboarding."
          />
          <div className="grid md:grid-cols-3 gap-6">
            {plans.map((plan) => (
              <Card key={plan.title}>
                <h3 className="text-2xl font-semibold">{plan.title}</h3>
                <p className="text-slate-200/80 mt-2">{plan.desc}</p>
                <ul className="space-y-2 mt-4 text-sm text-slate-200/80">
                  {plan.items.map((item) => (
                    <li key={item} className="flex items-center gap-2">
                      <CheckCircle2 className="w-4 h-4 text-[#FF6B35]" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PlanosPage;
